import { MobileMenu } from "./mobile-menu";

const mobileMenuOpen = document.querySelector("#mobile-menu-open");
const mobileMenuClose = document.querySelector("#mobile-menu-close");

if (mobileMenuOpen && mobileMenuClose) {
    const mobileMenuInstance = new MobileMenu(mobileMenuOpen, mobileMenuClose);
    mobileMenuInstance.init();
}

// Cookie notice
const cookieNotice = document.getElementById("cookie-notice");
const cookieAccept = document.getElementById("cookie-accept");

if (cookieNotice && cookieAccept) {
    if (localStorage.getItem("cookies-accepted")) {
        cookieNotice.remove();
    } else {
        cookieNotice.classList.add("visible");
        cookieAccept.addEventListener("click", () => {
            localStorage.setItem("cookies-accepted", "1");
            cookieNotice.remove();
        });
    }
}
